const fonts: FontChoice[] = [
    {
        fontUrl: "",
        fontFamily: "Arial, sans-serif"
    },
    {
        fontUrl: "",
        fontFamily: "'Brush Script MT', cursive",
    },
    {
        fontUrl: "",
        fontFamily: "'Courier New', monospace",
    },
    {
        fontUrl: "https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&display=swap",
        fontFamily: "Dancing Script"
    },
]

export type FontChoice = {
    fontUrl: string,
    fontFamily: string,
}

export {fonts} 